import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3841544c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "URL", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Display internal content such as graphs, intranet and your company website.", -1))
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Refresh Interval"),
  /*#__PURE__*/_createElementVNode("p", null, "Ditto refreshes the webpage every 10 minutes to ensure data is current.")
], -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Resolution", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Set the resolution of the webpage.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-1" }, "1080p", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1920 x 1080", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-1" }, "720p", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1280 x 720", -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  class: "w-auto pe-1",
  style: {"height":"55px"}
}
const _hoisted_15 = {
  class: "w-auto ps-0",
  style: {"height":"55px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("For more help, see "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-white",
    href: "https://help.airsquirrels.com/ditto/411-how-to-set-up-a-static-web-url-item-in-digital-signage?preview=6171c1cb9ccf62287e5ee5c9",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "how to set up a Static Web URL item in digital signage"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "row request-headers" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (!_ctx.isUrlValid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Invalid URL"))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { prop: "url" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: _normalizeClass({'url-invalid' : (!_ctx.isUrlValid),  'url-valid' : (_ctx.isUrlValid) }),
              modelValue: _ctx.signageItemLayoutData.url,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.url) = $event)),
              placeholder: "url",
              "suffix-icon": {'el-icon-warning url-invalid':(!_ctx.isUrlValid), 'el-icon-check url-valid':(_ctx.isUrlValid)}
            }, null, 8, ["class", "modelValue", "suffix-icon"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _hoisted_5,
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.signageItemLayoutData.resolution,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.resolution) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              class: "dt-radio",
              label: "1080p",
              border: ""
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              class: "dt-radio",
              label: "720p",
              border: ""
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_form_item, { label: "Use Request Header" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.useRequestHeader,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.useRequestHeader) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_popover, {
            "popper-class": "is-dark",
            trigger: "hover",
            placement: "right",
            width: 300
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_Icon, {
                  class: "dt-icon--small",
                  fill: "#949494",
                  icon: _ctx.mdiHelpCircle
                }, null, 8, ["icon"])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        (_ctx.signageItemLayoutData.useRequestHeader)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, "The Request Header is an HTTP header that can be used in an HTTP request to provide information about the request context, so that the server can tailor the response."))
          : _createCommentVNode("", true),
        (_ctx.signageItemLayoutData.useRequestHeader)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageItemLayoutData.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["d-flex align-items-center", { 'mb-2' :  index < _ctx.signageItemLayoutData.headers.length }]),
                    key: index
                  }, [
                    _createVNode(_component_el_input, {
                      placeholder: "Key",
                      class: "me-2",
                      modelValue: header.key,
                      "onUpdate:modelValue": ($event: any) => ((header.key) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_el_input, {
                      placeholder: "Value",
                      class: "me-2",
                      modelValue: header.value,
                      "onUpdate:modelValue": ($event: any) => ((header.value) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.signageItemLayoutData.headers.splice(index, 0 , {...header})),
                      type: "button",
                      class: "dt-icon-button"
                    }, [
                      _createVNode(_component_Icon, { icon: _ctx.mdiContentDuplicate }, null, 8, ["icon"])
                    ], 8, _hoisted_19),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.signageItemLayoutData.headers.splice(index, 1)),
                      type: "button",
                      class: "dt-icon-button"
                    }, [
                      _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
                    ], 8, _hoisted_20)
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  class: "mt-2",
                  type: "primary",
                  plain: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.signageItemLayoutData.headers.push({ key: '', value: '' });})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add")
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}